// 顶点着色器
export const vertexShader = `
    attribute float size;
    attribute float opacity;
    attribute vec3 color;

    varying vec3 vColor;
    varying float vOpacity;

    void main() {

        vColor = color;

        vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );

        gl_PointSize = size * ( 300.0 / -mvPosition.z );

        gl_Position = projectionMatrix * mvPosition;

        vOpacity = opacity;
    }
`;

// 片元着色器
export const fragmentShader = `
    uniform sampler2D pointTexture;

    varying vec3 vColor;
    varying float vOpacity;

    void main() {

        gl_FragColor = vec4( vColor, vOpacity );

        gl_FragColor = gl_FragColor * texture2D( pointTexture, gl_PointCoord );

    }
`;